export class Storage {
  private counter: number;
  private _showAdminMessages: boolean;
  private _showMessageDetails: boolean;
  private _showHeartbeats: boolean;
  private _caseInsensitive: boolean;
  private _dialect: string;
  private readonly since: number;

  constructor() {
    this._showAdminMessages = this.readBoolean("showAdminMessages");

    this._showHeartbeats = this.readBoolean("showHeartbeats");
    this._caseInsensitive = this.readBoolean("caseInsensitive", "true");
    this._showMessageDetails = this.readBoolean("showMessageDetails", "true");
    this._dialect = localStorage.getItem("dialect") ?? "auto";

    this.counter = parseInt(localStorage.getItem("count") ?? "0");

    this.since = parseInt(localStorage.getItem("since") ?? "0");
    if (this.since === 0) {
      this.since = new Date().getTime();
      localStorage.setItem("since", this.since.toString());
    }
  }

  private readBoolean(name: string, defaultValue = "false") {
    return (localStorage.getItem(name) ?? defaultValue) === "true";
  }

  incrementCounter(delta: number): number {
    this.counter += delta;
    localStorage.setItem("count", `${this.counter}`);
    return this.counter;
  }

  getSince(): number {
    return this.since;
  }

  getCounter(): number {
    return this.counter;
  }

  resetCounter() {
    this.counter = 0;
    localStorage.setItem("count", "0");
  }

  setShowMessageDetails(value: boolean) {
    this._showMessageDetails = value;
    localStorage.setItem("showMessageDetails", `${this._showMessageDetails}`);
  }

  setShowAdminMessages(value: boolean) {
    this._showAdminMessages = value;
    localStorage.setItem("showAdminMessages", `${this._showAdminMessages}`);
  }

  setShowHeartbeats(value: boolean) {
    this._showHeartbeats = value;
    localStorage.setItem("showHeartbeats", `${this._showHeartbeats}`);
  }

  setCaseInsensitive(value: boolean) {
    this._caseInsensitive = value;
    localStorage.setItem("caseInsensitive", `${this._caseInsensitive}`);
  }

  setDialect(value: string) {
    this._dialect = value;
    localStorage.setItem("dialect", `${this._dialect}`);
  }

  showAdminMessages(): boolean {
    return this._showAdminMessages;
  }

  showMessageDetails(): boolean {
    return this._showMessageDetails;
  }

  showHeartbeats(): boolean {
    return this._showHeartbeats;
  }

  caseInsensitive(): boolean {
    return this._caseInsensitive;
  }

  dialect(): string {
    return this._dialect;
  }
}
